export const TEXT_BLOCK_DATA_TEST_ID = 'text-block';
export const YPEC_SSS_YAMAHA_DOMAIN = 'ypec-sss.yamaha-motor';
